module.exports = "https://cdn.thelire.com/ins/resource/lh_post_close.f576f976efbc79f3985d8690c1812b3a.png";